import React from "react";
import areIntlLocalesSupported, { intl } from "intl-locales-supported";
import DatePicker from "material-ui/DatePicker";

const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }

  return date;
};

export const renderDateField = ({
  input,
  label,
  meta: { touched, error },
  elStyle,
  ...options
}) => {
  let DateTimeFormat;
  if (areIntlLocalesSupported(["id", "id-ID"])) {
    DateTimeFormat = global.Intl.DateTimeFormat;
  } else {
    const IntlPolyfill = intl;
    DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }

  return (
    <DatePicker
      {...input}
      errorText={touched && error}
      floatingLabelText={label}
      container="dialog"
      DateTimeFormat={DateTimeFormat}
      value={datify(input.value)}
      onChange={(event, value) => input.onChange(value)}
      onBlur={(event, value) => input.onBlur(value)}
      style={{ marRight: 10 }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/form/FieldForm.js